import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    flex: 1,
    marginRight: theme.spacing.xSmall,
    width: "205px",
    "@media (max-width: 360px)": {
        width: "56vw",
    },
    position: "relative",
}));
